import { Link, useMatch, useResolvedPath } from "react-router-dom"
import { motion } from 'framer-motion';




function ShowSidebar() {
    const sidebar = document.querySelector('.nav .sidebar');
    sidebar.style.display = 'flex';
}

function CloseSidebar() {
    const sidebar = document.querySelector('.nav .sidebar');
    sidebar.style.display = 'none';
}

// const sparkleVariants = [ Sparkle3, Sparkle4, Sparkle5 ]

// function Sparkles({isHover}) {
//     if(isHover) {return(
    
//     <div className="sparkles-container">
//         <div className="sparkles">
//             <img src={Sparkle3}/>
//         </div>
//         <div className="sparkles">
//         <img src={Sparkle4}/>   
//         </div>
//         <div className="sparkles">
//             <img src={Sparkle5}/>
//         </div>
//     </div>
//     );
//     }
// }

export default function NavBar() {

    return (
        <nav className="nav">
            <ul className="sidebar">
                <div onClick={CloseSidebar}>
                    <button className="close-symbol" style={{color: "#422d23"}}>
                        &times;
                    </button>
                </div>
                <CustomLink to="/graphicDesign">Design</CustomLink>
                <CustomLink to="/codingProjects">Coding</CustomLink>
                <CustomLink to="/artwork">Artwork</CustomLink>
                <CustomLink to="/contact">Contact</CustomLink>
            </ul>

           
                
        
            <CustomLink to="/" className="my-name">CELINE HUI</CustomLink> 

            
        
            
            <ul className="hide-on-mobile">
                <CustomLink to="/graphicDesign">Design</CustomLink>
                <CustomLink to="/codingProjects">Coding</CustomLink>
                <CustomLink to="/artwork">Artwork</CustomLink>
                <CustomLink to="/contact">Contact</CustomLink>
            </ul>
            <motion.div 
                className="menu-icon" 
                onClick={ShowSidebar}
                whileHover={{scale: 1.1}}
            >
                <span class="material-symbols-outlined" style={{color: "#422d23"}}>menu</span>
            </motion.div>
            
        </nav>
    )
}

function CustomLink({ to, children, ...props}) {
    const resolvedPath = useResolvedPath(to)
    const isActive = useMatch({path: resolvedPath.pathname, end: true})
    return (
        <motion.li className={isActive ? "active" : ""}
            whileHover={{scale: 1.07}}
        
        >
            <Link to={to} {...props}>
                {children}
            </Link>
        </motion.li>
    )
}